import React from 'react';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';


function StudentButtons() {
  const [enrolledCourses, setEnrolledCourses] =  useState([])
  const [disable, setDisable] = useState(false)

  useEffect(() => {
    async function fetchEnrolledCourses() {
      const user = auth.currentUser;
      if (user) {
        const userDocRef = doc(db, "users", user.uid);
        try {
          const userSnapshot = await getDoc(userDocRef);
          if (userSnapshot.exists()) {
            const userCourses = userSnapshot.data().enrolledCourses || [];
            setEnrolledCourses(userCourses)
         
            if(enrolledCourses.length === 3){
              setDisable(true)
            } 
          }


        }catch(err){
          console.error(err)
        }
    }
  }
  fetchEnrolledCourses()


    }, [auth.currentUser])
  
    
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate("/signupAppointment");
  };
 
  const handleAddCourse = () => {
    navigate('/StudentAddCourse');
  };
    return (
      <>
        <div className="student-button-mb-2">
          <Button variant="primary" onClick={handleSignUp} className='me-2 green-button '>
            Sign Up For Appointment
          </Button>
          <Button variant="success" className='me-2 red-button '
          onClick={() => navigate("/cancelAppointment") }
          >
            Cancel Appointment
          </Button>
          <Button className="me-2 green-button " variant="primary" onClick={handleAddCourse}>
            Add Course
          </Button>
        </div>
        
      </>
    );
  }
  
  

export default StudentButtons;